<script>
// const INITIAL_DELAY_ANIMATION_WORDS = 250
const DELAY_ANIMATION_WORD = 150

export default {
    name: 'BaseCard',

    props: {
        index: {
            type: Number,
            default: 0,
        },
    },
    data(){
        return {
            visible: false,
        }
    },

    mounted(){
        this.initCard()
    },

    methods: {
        initCard(){
            const timeoutMilliseconds = this.index * DELAY_ANIMATION_WORD //  + INITIAL_DELAY_ANIMATION_WORDS

            setTimeout(() => {
                this.visible = true
            }, timeoutMilliseconds)
        },
    },
}
</script>
